import {
  getApiBaseUrl,
  getValidAccessTokenWithRefresh,
  handleApiAuthError,
  handleUnauthorized
} from "@helpers/authSession"

const buildUrl = (path) => {
  const base = getApiBaseUrl().replace(/\/+$/, "")
  const normalized = path.startsWith("/") ? path : `/${path}`
  return `${base}${normalized}`
}

const parseJsonResponse = async (response) => {
  if (response.status === 204) return null
  const text = await response.text()
  if (!text) return null
  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

/**
 * Authenticated fetch to Nest migration API (replaces bare fetch + stale Amplify headers).
 */
export const adminsApiFetch = async (path, options = {}) => {
  const token = await getValidAccessTokenWithRefresh()
  if (!token) {
    handleUnauthorized("expired")
    throw new Error("Not authenticated")
  }

  const method = (options.method || "GET").toUpperCase()
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
    ...(options.headers || {})
  }

  const response = await fetch(buildUrl(path), {
    method,
    headers,
    body: options.body !== undefined ? JSON.stringify(options.body) : undefined,
    signal: options.signal
  })

  if (response.status === 401 || response.status === 403) {
    const err = new Error(`Unauthorized (${response.status})`)
    err.status = response.status
    err.response = { status: response.status }
    handleApiAuthError(err)
    throw err
  }

  if (!response.ok) {
    const text = await response.text()
    const err = new Error(text || `Request failed (${response.status})`)
    err.status = response.status
    err.response = { status: response.status }
    throw err
  }

  return parseJsonResponse(response)
}

export const adminsApiGet = (path, options = {}) =>
  adminsApiFetch(path, { ...options, method: "GET" })

export const adminsApiPost = (path, body, options = {}) =>
  adminsApiFetch(path, { ...options, method: "POST", body })

export const adminsApiPut = (path, body, options = {}) =>
  adminsApiFetch(path, { ...options, method: "PUT", body })

export const adminsApiDel = (path, options = {}) =>
  adminsApiFetch(path, { ...options, method: "DELETE" })
